var React = require('react');

function Facebookwhite (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Facebook"},React.createElement("path",{"id":"Combined Shape","fillRule":"evenodd","clipRule":"evenodd","d":"M30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0ZM32.1269 30.3178V46.6393H25.3738V30.3184H22V24.6939H25.3738V21.317C25.3738 16.7285 27.2789 14 32.6915 14H37.1976V19.6251H34.381C32.274 19.6251 32.1346 20.4112 32.1346 21.8781L32.1269 24.6933H37.2295L36.6324 30.3178H32.1269Z","fill":"#414042"})));
}

Facebookwhite.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = Facebookwhite;

Facebookwhite.default = Facebookwhite;
